
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgContinuebutton = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#continuebutton_15312428559ffcbe__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 19.75c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.163-16-16Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.74 24.206a.874.874 0 0 1-.067 1.304 1.063 1.063 0 0 1-1.323.019l-.09-.081-5-5.077a.87.87 0 0 1-.08-1.15l.08-.092 5-5.077a1.06 1.06 0 0 1 1.412-.062.873.873 0 0 1 .146 1.213l-.078.091-4.39 4.455 4.39 4.457Z",
  fill: "var(--theme-primary, #810ea9)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "continuebutton_15312428559ffcbe__a",
  x: 0,
  y: 0,
  width: 44,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.505882 0 0 0 0 0.054902 0 0 0 0 0.662745 0 0 0 0.11 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_20188_79924"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_20188_79924",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g filter=\"url(#filter0_d_20188_79924)\">\r\n<path d=\"M6 19.75C6 10.9134 13.1634 3.75 22 3.75C30.8366 3.75 38 10.9134 38 19.75C38 28.5866 30.8366 35.75 22 35.75C13.1634 35.75 6 28.5866 6 19.75Z\" fill=\"white\"/>\r\n<path d=\"M24.7398 24.206C25.1113 24.5832 25.0812 25.167 24.6725 25.5099C24.2953 25.8265 23.7274 25.8272 23.3501 25.5287L23.2599 25.4478L18.2599 20.3709C17.9421 20.0482 17.9156 19.5695 18.1805 19.2207L18.2599 19.1291L23.2599 14.0522C23.6314 13.6749 24.2639 13.6471 24.6725 13.9901C25.0498 14.3066 25.1044 14.8284 24.8184 15.2035L24.7398 15.294L20.3509 19.7491L24.7398 24.206Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</g>\r\n<defs>\r\n<filter id=\"filter0_d_20188_79924\" x=\"0\" y=\"0\" width=\"44\" height=\"44\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"2.25\"/>\r\n<feGaussianBlur stdDeviation=\"3\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.505882 0 0 0 0 0.054902 0 0 0 0 0.662745 0 0 0 0.11 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_20188_79924\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_20188_79924\" result=\"shape\"/>\r\n</filter>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/continuebutton.15312428559ffcbe7296ed15ec786a7f.svg"),
        {
          React: SvgContinuebutton,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      